// extracted by mini-css-extract-plugin
export default {"container":"Rate_container__gj1Ta"};